module.exports = __webpack_public_path__ + "img/sudbury_b3.02e9661d.jpg";